import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular/src/interfaces';

@Component({
  selector: 'app-view-attachment-file',
  templateUrl: './view-attachment-file.component.html',
  styleUrls: ['./view-attachment-file.component.scss']
})
export class ViewAttachmentFileComponent implements ICellRendererAngularComp {

  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  /**
   * @description
   * @returns {boolean}
   */
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  /**
   * @name getIcon
   * @description Retornar icono
   */
  getIcon () {
    let classIco = 'm-btn-warning';

    if (String(this.params.value) !== 'undefined' ) {
    classIco = 'fa fa-file';
    }


    return classIco;
  }

  public showAttachment() {
    if (String(this.params.value) === 'undefined' ) {
      return;
    }else {
      window.open(this.params.value, '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/view-attachment-file/view-attachment-file.component.ts